import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { CommonProvider } from '../../commonServices/common';
import { Apiurl } from '../../commonServices/route';
import { IonSearchbar, LoadingController, ModalController, NavParams } from "@ionic/angular";
import { Country } from 'src/data/country-location';
import { CompetitionInfo } from 'src/data/competition-data';
import { GameRoundInfo } from 'src/data/game-round';
import { PlayerService } from 'src/providers/player-service/player-service';


@Component({
  selector: 'app-country-list',
  templateUrl: './country-list.page.html',
  styleUrls: ['./country-list.page.scss'],
})
export class CountryListPage implements OnInit {
  
  @ViewChild('searchbar', { static: false }) searchbar: IonSearchbar;

  public headerName: string = 'Select preferred region';
  public competition: CompetitionInfo;
  public gameRound: GameRoundInfo;
  public countryList: Array<Country>;
  searchQuery: string;
  originalList: Array<Country>;
  excludeAll: boolean = false;

  countryListType: string = 'all';

  constructor(public modalController: ModalController,
    public http: HttpClient, private navParams: NavParams,
    private loadingCtl: LoadingController,
    private playerService: PlayerService,
    private flightService: ClubFlightService
  ) {
    this.competition = this.navParams.get("competition");
    this.gameRound = this.navParams.get("gameRound");
    this.headerName = this.navParams.get("headerName");
    this.excludeAll = this.navParams.get("excludeAll");
    this.countryListType = this.navParams.get("countryListType");
  }


 


  ngOnInit() {
    if(this.countryListType === 'clubCountries') {
      this.getClubCountries();
    } else this.getCountry();
  }

  
  ionViewDidEnter() {
    setTimeout(() => {
      // this.yourElement.nativeElement.focus();
      this.searchbar.setFocus();
    }, 500);
  }


  getInnerHTML() {
    let description = "<p><span style='background-color:#00FFFF'>Tournaments, electronic scorecards, analysis and more&hellip; Look no further! myGolf2u is a single place where you can find and register for any </span>competitions in your region, your favourite clubs or in the entire country on your phone or in this site.</p>"
    return description;
  }


  close() {
    this.modalController.dismiss(-999);
  }

  // ionViewWillEnter() {

  //   this.getCountry();
  // }



  countrySelected(country?: any) {
    if (country === null)
      this.modalController.dismiss(-999);
    else this.modalController.dismiss(country);
  }




  async getCountry(cb?) {
    let loader = await this.loadingCtl.create({
      message: "Getting Country List...",
      showBackdrop: false
    });
    loader.present().then(() => {
      this.playerService.getCountryList()
        .subscribe((data: Array<Country>) => {
          loader.dismiss().then(() => {
            // console.log("Country Sign Up : ",data)
            this.countryList = data;
            this.originalList = data;
            // console.log("Country List Sign Up : ", this.countryList)
          })
        }), (error) => {
          loader.dismiss();
        }, () => {
          loader.dismiss();
        };
    })



    // setTimeout(()=>{
    //     console.log("Get country calling back");
    //     cb();

    // }, 0)
  }
  
  async getClubCountries(cb?) {
    let loader = await this.loadingCtl.create({
      message: "Getting Country List...",
      showBackdrop: false
    });
    loader.present().then(() => {
      this.flightService.getClubCountryList()
        .subscribe((data: Array<Country>) => {
          loader.dismiss().then(() => {
            // console.log("Country Sign Up : ",data)
            this.countryList = data;
            this.originalList = data;
            // console.log("Country List Sign Up : ", this.countryList)
          })
        }), (error) => {
          loader.dismiss();
        }, () => {
          loader.dismiss();
        };
    })



    // setTimeout(()=>{
    //     console.log("Get country calling back");
    //     cb();

    // }, 0)
  }

  getFlagUrl(flagUrl: string) {
    if (flagUrl == null) return null;
    else {
      let flagIcon = flagUrl.split("/");
      // console.log("assets/img/flag/" + flagIcon[2])
      return "assets/img/flag/" + flagIcon[2];
    }
  }





  onSearchInput(event) {
    this.searchQuery = event;
    this.countryList = this.originalList;

    if (this.searchQuery.length == 0) return false;
    let _country: any;
    this.countryList = this.countryList.filter((country: any) => {
      // return country.name.toLowerCase().trim().includes(this.searchQuery.toLowerCase().trim())
      if (country.name.toLowerCase().trim().includes(this.searchQuery.toLowerCase().trim()))
        return 1
      else if (country.id.toLowerCase().trim().includes(this.searchQuery.toLowerCase().trim()))
        return 1
      // else if(country.sportCode.toLowerCase().trim().includes(this.searchQuery.toLowerCase().trim()))
      //     return 1
      else return 0

    })
  }

  onSearchCancel() {
    this.countryList = this.originalList
  }


}
